<template>
  <div>
    <div class="section has-text-left">
      <router-link
        v-if="newCardTipology"
        :to="newCardTipology"
        class="button is-success"
      >
        <b-icon icon="plus-square" size="is-small"></b-icon>
        <span>Aggiungi</span>
      </router-link>
    </div>

    <section class="section has-text-left">
      <div class="columns">
        <div class="column" v-if="$ajax.getUserRole().cardUnlock">
          <ServiceTipologyDD v-model="tipologyId" expanded></ServiceTipologyDD>
        </div>
        <div class="column">
          <b-field label="From">
            <b-datepicker
              placeholder="Click to select..."
              v-model="searchFilter.from"
              :max-date="maxDate"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field label="To">
            <b-datepicker
              placeholder="Click to select..."
              v-model="searchFilter.to"
              :max-date="maxDate"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="column is-half">
          <!-- SEARCH SALES POINTS -->
          <SearchGeneric
            preload="true"
            apiaddress="/salespoints/search"
            label="Sales point"
            :nameFormat="nameFormatSalesPoint"
            :searchOnFields="salesPointSearchFields"
            v-on:eventSelected="handleSalesPointSelected"
            nullable
          ></SearchGeneric>
        </div>
      </div>

      <!--<pre>{{ searchFilter }}</pre>
        -->

      <b-button type="is-info" v-on:click="loadAsyncData">Aggiorna</b-button>
    </section>
    <!--
    <b-pagination
      :total="total"
      v-model="currentPage"
      :range-before="4"
      :range-after="4"
      :per-page="perPage"
      order="is-right"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
    </b-pagination>-->
    <b-table
      :data="dataList"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :loading="$ajax.anyLoading"
      :total="total"
      :pagination-range-before="10"
      :pagination-range-after="10"
      paginated
      striped
      backend-pagination
      class="has-text-left"
    >
      <!-- v-on:page-change="onPageChange" -->
      <template>
        <b-table-column v-slot="props">
          <router-link
            :to="`/card/${getTipologyName(props.row.tipologyId)}/${
              props.row.id
            }`"
          >
            <i class="fas fa-eye"></i>
            Apri scheda
          </router-link>
        </b-table-column>

        <b-table-column field="exposedAt" label="Data esercizio" v-slot="props">
          <span class="tag">{{ props.row.exposedAt | date }}</span>
        </b-table-column>

        <b-table-column field="promoter" label="Promoter" v-slot="props">{{
          props.row.promoter.name
        }}</b-table-column>
        <b-table-column field="customer" label="Cliente" v-slot="props">{{
          props.row.customer.name
        }}</b-table-column>
        <b-table-column field="customer" label="Città" v-slot="props">{{
          props.row.salePoint.city
        }}</b-table-column>

        <b-table-column
          field="salesPointName"
          label="Sales Point"
          v-slot="props"
        >
          {{ props.row.salePoint.name | truncate(30) }}
          <span class="tag is-light" v-if="props.row.salePoint.ensign">{{
            props.row.salePoint.ensign
          }}</span>
        </b-table-column>

        <b-table-column
          width="30"
          field="distinct-products"
          label="P"
          v-slot="props"
          numeric
          >{{ props.row.productCount || null }}</b-table-column
        >
        <b-table-column
          width="30"
          field="total-products"
          label="V"
          numeric
          v-slot="props"
          >{{ props.row.productTotal || null }}</b-table-column
        >

        <b-table-column
          width="10"
          field="locked"
          class="has-text-right"
          v-slot="props"
        >
          <b-tooltip
            v-if="$ajax.getUserRole().cardUnlock"
            :label="
              props.row.locked ? 'Clicca per sbloccare' : 'Clicca per bloccare'
            "
            position="is-left"
          >
            <a
              class="button is-small"
              :class="{ 'is-warning': props.row.locked }"
              :disabled="$ajax.anyLoading"
              v-on:click.prevent="switchLockTest(props.row)"
            >
              <b-icon
                :icon="props.row.locked ? 'lock' : 'unlock'"
                type
              ></b-icon>
            </a>
          </b-tooltip>
          <b-icon
            icon="lock"
            size="is-small"
            type="is-danger"
            v-else-if="props.row.locked"
          ></b-icon>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="list " size="is-large"></b-icon>
            </p>
            <p>Nessuna scheda disponibile</p>
          </div>
        </section>
      </template>
    </b-table>

    <br />
    <b-pagination
      :total="total"
      v-model="currentPage"
      :range-before="8"
      :range-after="8"
      :simple="isPaginationSimple"
      :per-page="perPage"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      order="is-centered"
    >
      <!--       @change="(p) => onPageChange(p)"-->
    </b-pagination>
  </div>
</template>

<script>
import ServiceTipologyDD from "@/components/dropdown/ServiceTipologyDD";
import SearchGeneric from "@/components/SearchGeneric";

export default {
  name: "cards",
  components: {
    SearchGeneric,
    ServiceTipologyDD,
  },
  data() {
    return {
      tipologyId: null,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 30,
      total: 0,
      dataList: [],
      salesPointSearchFields: ["name", "ensign", "city"],
      nameFormatSalesPoint: (data) => {
        return `${data.name} [${data.ensign}]`;
      },
      maxDate: new Date(),
      searchFilter: {
        from: new Date(new Date().getFullYear(), 0, 1), // first day of year
        to: new Date(), // today
        salesPointId: 0,
        userId: this.$route.query.user_id,
      },
    };
  },
  computed: {
    newCardTipology() {
      var role = this.$ajax.getUserRole();
      if (role.tipologyId == null && this.tipologyId)
        return `/card/${this.getTipologyName(this.tipologyId)}/`;

      switch (+role.tipologyId) {
        case 1:
          return "/card/promoter/";
        case 2:
          return "/card/ambassador/";
        default:
      }

      return;
    },
  },
  methods: {
    getTipologyName(tipologyId) {
      if (tipologyId == 1) return "promoter";
      if (tipologyId == 2) return "ambassador";
      throw Error("tipologia inesistente");
    },
    switchLockTest(card) {
      this.$ajax.request({
        address: `/cards/${this.getTipologyName(card.tipologyId)}/${
          card.id
        }/lock`,
        method: "PUT",
        data: { id: card.id, locked: !card.locked },
        silent: true,
        onSuccess: (response) => {
          // response.data.forEach(item => vm.dataList.push(item));
          card.locked = response.data.locked;
        },
      });
    },
    onPageChange(page) {
      if (!page) {
        page = 1;
        console.warn(`onPageChange requested invalid page '${page}' `);
      }

      var ppage = parseInt(page);

      var oldPage = this.currentPage;
      this.currentPage = ppage;
      this.loadAsyncData(oldPage, ppage);
    },
    loadAsyncData(oldPage, newPage) {
      newPage = parseInt(newPage);
      if (!newPage) newPage = 1;

      const vm = this;
      const params = [
        `skip=${(newPage - 1) * this.perPage}`,
        `take=${this.perPage}`,
      ].join("&");

      this.$ajax.request({
        //address: `/cards${user_id}?${params}`,
        address: `/cards/${this.getTipologyName(
          this.tipologyId
        )}/filter?${params}`,
        data: this.searchFilter,
        method: "POST",
        onSuccess: (response) => {
          //if (page > 0)
          //window.history.pushState(
          //  "page",
          //  "cards",
          //  `/cards/${vm.currentPage}`
          //);

          //if (oldPage != newPage)
          //  this.$router.push({
          //    query: { ...this.$route.query, page: newPage },
          //  });

          this.total = response.data.totalRowsCount;
          vm.dataList.splice(0, vm.dataList.length);

          response.data.results.forEach((item) => vm.dataList.push(item));
        },
      });
    },
    handleSalesPointSelected(selected) {
      this.searchFilter.salesPointId = selected ? selected.id : 0;
    },
  },
  watch: {
    tipologyId: function (newVal) {
      //console.warn("!!!", newVal);
      //window.history.pushState("page", "cards", `/cards/1`);
    },
    // https://stackoverflow.com/questions/46878528/vuejs-bind-input-to-url-param
    //    "searchFilter.userId"(newVal) {
    //      if (!newVal) return;
    //
    //      this.$router.push({ query: { ...this.$route.query, userId: newVal } });
    //    },
    //    "$route.query.userId": function (val) {
    //      this.searchFilter.userId = val;
    //    },
    currentPage(newVal, oldVal) {
      this.$router.push({ query: { ...this.$route.query, page: newVal } });
    },
    "$route.query.page"(newVal, oldVal) {
      if (newVal == oldVal) return;
      this.onPageChange(newVal);
    },
    "$route.query.user_id"(newVal, oldVal) {
      this.searchFilter.userId = this.$route.query.user_id;
    },
  },
  //created() {
  //  if (this.$route.params.user_id)
  //    this.searchFilter.userId = this.$route.query.user_id;
  //},
  mounted() {
    //TODO: initial set currentPage() ??
    // needed to wait defaults (tipology field) from localStorage
    this.$nextTick(function () {
      var defaultId = this.$ajax.getUserRole().tipologyId;
      if (defaultId) this.tipologyId = defaultId;

      if (this.tipologyId) {
        //this.onPageChange(this.$route.query.page);
        this.searchFilter.userId = this.$route.query.user_id;

        var p = this.$route.query.page ? this.$route.query.page : 1;
        this.$router.push({ query: { ...this.$route.query, page: p } });
        this.onPageChange(p);
      }

      // TODO: scopri come gestire correttamente la history di navigazione
    });
  },
};
</script>
